import { render, staticRenderFns } from "./AktivitaetModalNewViva.vue?vue&type=template&id=286d83e0&scoped=true"
import script from "./AktivitaetModalNewViva.vue?vue&type=script&lang=js"
export * from "./AktivitaetModalNewViva.vue?vue&type=script&lang=js"
import style0 from "./AktivitaetModalNewViva.vue?vue&type=style&index=0&id=286d83e0&prod&scoped=true&lang=css"
import style1 from "./AktivitaetModalNewViva.vue?vue&type=style&index=1&id=286d83e0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "286d83e0",
  null
  
)

export default component.exports